import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  relleno?: "ninguno" | "normal";
}

export function Card({ relleno = "normal", className, ...props }: CardProps) {
  return (
    <div
      className={cn(
        "rounded-tarjeta border border-borde bg-superficie shadow-tarjeta",
        relleno === "normal" && "p-5 sm:p-6",
        className,
      )}
      {...props}
    />
  );
}
